"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.MenuButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
// React imports
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var chevron_1 = __importDefault(require("../svgs/chevron"));
/**
 * A menu button that displays a dropdown menu when clicked
 */
var MenuButton = /** @class */ (function (_super) {
    __extends(MenuButton, _super);
    /**
     * Constructor function for the component
     * @param props - The props passed to the component
     */
    function MenuButton(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Toggles the visibility of the menu on click
         */
        _this.handleMenuButtonClick = function (event) {
            event.stopPropagation();
            if (_this.props.disabled !== true) {
                _this.setState({ showMenu: !_this.state.showMenu });
            }
        };
        /**
         * Handles clicks outside the menu, hiding the menu if necessary
         * @param event - the mouse event that occurred
         */
        _this.handleClickOutside = function (event) {
            var target = event.target;
            if (!target.closest('.menu-button-section') ||
                Array.from(target.classList).includes('chakra-select-button')) {
                _this.setState({ showMenu: false });
            }
        };
        _this.handleFocus = function () {
            // Open menu when MenuButton is focused
            _this.setState({ showMenu: true });
        };
        _this.handleKeyDown = function (event) {
            var _a;
            if (event.key === 'Tab') {
                var menuItems = (_a = _this.menuRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll("button, a, [tabindex='0']");
                if (menuItems) {
                    var lastItem = menuItems[menuItems.length - 1];
                    if (!event.shiftKey && document.activeElement === lastItem) {
                        _this.setState({ showMenu: false }); // Close menu when tabbing out from last item
                    }
                }
            }
        };
        _this.handleBlur = function (event) {
            setTimeout(function () {
                var _a;
                var focusedElement = document.activeElement;
                // Close the menu only if the new focused element is NOT inside the menu or the menu button
                if (!((_a = _this.menuRef.current) === null || _a === void 0 ? void 0 : _a.contains(focusedElement)) &&
                    focusedElement !== _this.menuButtonRef.current) {
                    _this.setState({ showMenu: false });
                }
            }, 0); // Timeout allows new focus to be determined before closing the menu
        };
        _this.state = { showMenu: false };
        _this.menuButtonRef = react_1["default"].createRef();
        _this.menuRef = react_1["default"].createRef();
        return _this;
    }
    /**
     * Adds an event listener for clicks outside the component, and removes it when the component unmounts
     */
    MenuButton.prototype.componentDidMount = function () {
        window.addEventListener('click', this.handleClickOutside);
    };
    MenuButton.prototype.componentWillUnmount = function () {
        window.removeEventListener('click', this.handleClickOutside);
    };
    /**
     * Renders the component
     * @returns The rendered component
     */
    MenuButton.prototype.render = function () {
        var _a = this.props, style = _a.style, className = _a.className, prefixTitle = _a.prefixTitle, label = _a.label, icon = _a.icon, disabled = _a.disabled, defaultLabel = _a.defaultLabel, secondaryLabel = _a.secondaryLabel;
        var showMenu = this.state.showMenu;
        // Check if label prop is present, if not, use default label
        var renderedLabel = label ? label : defaultLabel;
        // Determine the class name for the label span
        var labelClassName = (0, classnames_1["default"])({
            'chakra-button-label': label,
            'default-button-label': !label && defaultLabel // Apply default-button-label style if label is not present and defaultLabel is present
        });
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "menu-button-section" }, { children: [(0, jsx_runtime_1.jsxs)("button", __assign({ style: style, ref: this.menuButtonRef, onMouseDown: this.handleMenuButtonClick, onFocus: this.handleFocus, onBlur: this.handleBlur, className: (0, classnames_1["default"])('chakra-secondary-button', className !== null && className !== void 0 ? className : '', 'menu-main-button', {
                        'menu-main-button-active': showMenu
                    }) }, { children: [(0, jsx_runtime_1.jsxs)("span", __assign({ className: labelClassName, onMouseDown: this.handleMenuButtonClick }, { children: [prefixTitle, renderedLabel] })), icon && (0, jsx_runtime_1.jsx)("span", __assign({ className: "menu-section-icon" }, { children: icon })), disabled !== true &&
                            !icon && ( // Only render Chevron if not disabled and icon is not present
                        // Removed onClick from Chevron to prevent duplicate triggers of handleMenuButtonClick.
                        // The button already handles onMouseDown, and click on Chevron was bubbling up and causing double execution.
                        (0, jsx_runtime_1.jsx)(chevron_1["default"], { className: "menu-section-icon" })), secondaryLabel && ((0, jsx_runtime_1.jsx)("span", __assign({ className: "secondary-label" }, { children: secondaryLabel })))] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1["default"])('chakra-menu-section', {
                        'chakra-active-menu': this.state.showMenu
                    }), ref: this.menuRef, onKeyDown: this.handleKeyDown }, { children: this.props.children }))] })));
    };
    return MenuButton;
}(react_1["default"].Component));
exports.MenuButton = MenuButton;
//# sourceMappingURL=menu-button.js.map